import React, { useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { yupResolver } from '@hookform/resolvers/yup'

import styles from './InviteUser.module.css'

import SlideOverModal from 'Layout/SlideOverModal'

import Button from 'Design/components/Button'
import FormControl from 'Design/components/FormControl'
import Label from 'Design/components/Label'
import Input from 'Design/components/Input'
import FormErrorText from 'Design/components/FormErrorText'

import Permissions from '../components/Permissions'
import Authorized from '../../../../../components/Authorized'

import inviteUserFormValidationSchema from './inviteuser-form-validation-schema'
import { useInviteUserMutation } from '../users.service'

const InviteUserModal = (props) => {
  const { hide } = props

  const {
    register,
    handleSubmit,
    control,
    formState: { errors }
  } = useForm({
    defaultValues: {
      name: '',
      email: '',
      permissions: []
    },
    resolver: yupResolver(inviteUserFormValidationSchema)
  })

  const [inviteUser, inviteUserResult] = useInviteUserMutation()

  const handleFormSubmit = (data) => {
    const payload = {
      name: data.name,
      email: data.email,
      permissions: data.permissions
    }

    const promise = inviteUser(payload).unwrap()

    toast.promise(promise, {
      loading: 'Inviting user',
      success: `Invited user '${data.name}'. Sucessfully...`,
      error: `Error while inviting user '${data.name}'. Try again.`
    })

    promise.then(hide)
  }

  return (
    <SlideOverModal title='Invite User' onHide={hide}>
      <form onSubmit={handleSubmit(handleFormSubmit)} className={styles.Form}>
        <FormControl isInvalid={errors.name}>
          <Label>Name</Label>
          <Input {...register('name')} />
          {errors.name && <FormErrorText>{errors.name.message}</FormErrorText>}
        </FormControl>
        <FormControl isInvalid={errors.email}>
          <Label>Email</Label>
          <Input {...register('email')} />
          {errors.email && <FormErrorText>{errors.email.message}</FormErrorText>}
        </FormControl>
        <Controller
          control={control}
          name='permissions'
          render={({ field: { value, onChange } }) => {
            return <Permissions permissions={value} onChange={onChange} />
          }}
        />
        <div className={styles.ButtonsContainer}>
          <Button type='submit' variant='primary' disabled={inviteUserResult.isLoading}>
            Invite
          </Button>
          <Button variant='link-muted' onClick={hide} disabled={inviteUserResult.isLoading}>
            Cancel
          </Button>
        </div>
      </form>
    </SlideOverModal>
  )
}

const InviteUser = () => {
  const [showInviteUserModal, setShowInviteUserModal] = useState(false)

  const handleInviteUserClick = () => {
    setShowInviteUserModal(true)
  }

  const hide = () => {
    setShowInviteUserModal(false)
  }

  return (
    <Authorized permissions={['user_invite']}>
      {showInviteUserModal && <InviteUserModal hide={hide} />}
      <Button variant='primary' onClick={handleInviteUserClick}>
        Invite User
      </Button>
    </Authorized>
  )
}

export default InviteUser
